import {useMemo} from 'react'
import {
  Button, Select, Flex, DropDown, Box, TextButton
} from '@binance/uikit'
import styled from 'styled-components'

const LeftPanel = styled.ul`
  display: ${({hidden}) => (hidden ? 'none' : 'flex')};
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 12px;
`

const HoverPanelItem = styled.li`
  align-items: center;
  cursor: pointer;

  background-color: ${({theme}) => theme.boxbg};
  border: 1px solid transparent;

  display: ${({hidden}) => (hidden ? 'none' : 'flex')};
  margin: 1px 0.1em;
  padding: 0;
  position: relative;

  padding-left: 3px;
  padding-right: 20px;
  margin-left: 5px;
  cursor: pointer;
  line-height: 16px;
  & > i {
    font-size: 12px;
    margin-left: 3px;
    padding: 0 3px;
    line-height: 16px;
    margin-right: -1px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    font-style: normal;
  }
  & :hover {
    border-color: #deac37;
    color: #deac37;
  }

  & :hover i {
    background: #deac37;
    color: #fff;
  }
`

const SelectWrap = styled(Box)`
  width: 174px;
  background: #2f383f;
  overflow: hidden;
  padding: 6px;
`

const IndSelectWrap = styled(Box)`
  display: flex;
  width: 200px;
  padding: 8px;
  flex-direction: row;
  flex-wrap: wrap;
  background: rgba(33, 40, 51, 0.98);
`
const Ind = styled.div`
  display: flex;
  flex: 0 10 20%;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 19px;
  color: #848e9c;
  padding: 4px;
`

const OptionBox = styled(TextButton)`
  float: left;
  width: 50%;
  padding: 10px 20px;
  margin: 0;
  box-sizing: border-box;
  font-size: 12px;
  padding: 4px 20px;
  color: #d4d4d4;
`

const INDS = [
  {display: 'MACD', value: 'MACD'},
  {display: 'TRIX', value: 'TRIX'},
  {display: 'KDJ', value: 'KDJ'},
  {display: 'StochRSI', value: 'StochRSI'},
  {display: 'RSI', value: 'RSI'},
  {display: 'EMV', value: 'EMV'},
  {display: 'DMI', value: 'DMI'},
  {display: 'WR', value: 'WR'},
  {display: 'OBV', value: 'OBV'},
  {display: 'BOLL', value: 'BOLL'},
  {display: 'MTM', value: 'MTM'},
  {display: 'SAR', value: 'SAR'},
  {display: 'EMA', value: 'EMA'},
  {display: 'CCI', value: 'CCI'},
  {display: 'VWAP', value: 'VWAP'},
  {display: 'MA', value: 'MA'},
  {display: 'AVL', value: 'AVL'},
  {display: 'VOL', value: 'VOL'}
]

const {Option} = Select
const minutes = [1, 3, 5, 15, 30]
const mKey = 'm'
const getMOptions = (i18n, setIntervals) => {
  const mLabel = i18n['unit-minute'] || 'm'
  return minutes.map(v => (
    <Ind
      key={`${v}${mKey}`}
      value={`${v}${mKey}`}
      onClick={() => setIntervals(`${v}${mKey}`)}
    >{`${v}${mLabel}`}</Ind>
  ))
}
const hours = [1, 2, 4, 6, 12]
const hKey = 'h'
const getHOptions = (i18n, setIntervals) => {
  const hLabel = i18n['unit-hour'] || 'h'
  return hours.map(v => (
    <Ind
      key={`${v}${hKey}`}
      value={`${v}${hKey}`}
      onClick={() => setIntervals(`${v}${hKey}`)}
    >{`${v}${hLabel}`}</Ind>
  ))
}
const oTimes = ['1D', '1W', '1M']
const getTOptions = (i18n, setIntervals) =>
  oTimes.map(v => (
    <Ind key={`${v}`} value={`${v}`} onClick={() => setIntervals(v)}>{`${i18n[v] || v}`}</Ind>
  ))
const getColor = hasColor => (hasColor ? 'primary' : undefined)
const lineTypes = ['Candle', 'Line']

export default function OptPanel (props) {
  const {
    interval,
    setIntervals,
    setIndicator,
    lineType,
    setLineType,
    i18n,
    view,
    curIndicator,
    setCurIndicator,
    setIndName
  } = props
  const hOptions = getHOptions(i18n, setIntervals)
  const mOptions = getMOptions(i18n, setIntervals)
  const tOptions = getTOptions(i18n, setIntervals)

  return useMemo(
    () => (
      <Flex alignItems="center">
        <Button
          ml={0}
          variant="small"
          glossy={false}
          onClick={() => {
            setLineType(lineTypes[1])
            setIntervals('')
          }}
          color={getColor(lineType === lineTypes[1])}
        >
          {i18n['graph-time'] || 'Time'}
        </Button>

        <DropDown
          tigger="hover"
          isFixed={true}
          overlay={
            <IndSelectWrap>
              {mOptions}
              {hOptions}
              {tOptions}
            </IndSelectWrap>
          }
        >
          <Button glossy={false} variant="small" color={getColor(interval !== '')}>
            {interval || `${minutes[0]}${mKey}`}
            <svg
              style={{marginLeft: 4}}
              width="6"
              height="4"
              viewBox="0 0 6 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.87006 0.855655L3.30346 3.85338C3.22681 3.9466 3.1163 4 3.00008 4C2.88394 4 2.77343 3.9466 2.69668 3.85338L0.130181 0.855655C0.00489473 0.714313 -0.0338278 0.508304 0.0309405 0.326341C0.0957088 0.144457 0.252008 0.0173411 0.433562 0L5.56455 0C5.7468 0.016602 5.90384 0.1429 5.96853 0.325602C6.03407 0.508304 5.99534 0.713574 5.87006 0.855655Z"
                fill={`#${interval ? 'F0B90B' : '848E9C'}`}
              />
            </svg>
          </Button>
        </DropDown>

        {view === 'default' ? (
          <DropDown
            tigger="click"
            isFixed={true}
            overlay={
              <SelectWrap>
                {INDS.map((v, i) => (
                  <OptionBox key={i} onClick={() => setIndName(v.value)}>
                    {v.display}
                  </OptionBox>
                ))}
              </SelectWrap>
            }
          >
            <Button variant="small" glossy={false}>
              {i18n['graph-Ind'] || 'Ind'}
            </Button>
          </DropDown>
        ) : (
          <Button variant="small" glossy={false} onClick={() => setIndicator(d => !d)}>
            {i18n['graph-Ind'] || 'Ind'}
          </Button>
        )}

        <LeftPanel hidden={view !== 'default'}>
          <HoverPanelItem hidden={!curIndicator.curInd}>
            {curIndicator.curInd}
            <i
              onClick={() => {
                setCurIndicator({curInd: null})
              }}
              role="menuitem"
              tabIndex="0"
              onKeyDown={() => {
                setCurIndicator({curInd: null})
              }}
            >
              ✕
            </i>
          </HoverPanelItem>
          <HoverPanelItem hidden={!curIndicator.curOver}>
            {curIndicator.curOver}
            <i
              onClick={() => {
                setCurIndicator({curOver: null})
              }}
              role="menuitem"
              tabIndex="0"
              onKeyDown={() => {
                setCurIndicator({curOver: null})
              }}
            >
              ✕
            </i>
          </HoverPanelItem>
        </LeftPanel>
      </Flex>
    ),
    [
      lineType,
      i18n,
      mOptions,
      hOptions,
      tOptions,
      interval,
      view,
      curIndicator.curInd,
      curIndicator.curOver,
      setLineType,
      setIntervals,
      setIndName,
      setIndicator,
      setCurIndicator
    ]
  )
}
